import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  expiresAt: string | null;
  isAuthenticated: boolean;
  login: (token: string, expiresAt: string) => void;
  logout: () => void;
  checkAuth: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      expiresAt: null,
      isAuthenticated: false,

      login: (token, expiresAt) => {
        set({ token, expiresAt, isAuthenticated: true });
      },

      logout: () => {
        set({ token: null, expiresAt: null, isAuthenticated: false });
      },

      checkAuth: () => {
        const { token, expiresAt } = get();
        if (!token || !expiresAt) {
          return false;
        }
        if (new Date(expiresAt) < new Date()) {
          get().logout();
          return false;
        }
        return true;
      },
    }),
    {
      name: 'nordcrest-admin-auth',
    }
  )
);
